import React, { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'

interface propsType {
  toggleModal: () => void
  selectedRef: any
  onSave: (data: ReferenceUpdate) => Promise<void>
}

export type ReferenceUpdate = {
  fullName: string
  occupation: string
  phoneNumber: string
  emailAddress: string
  address: string
}

const schema = yup.object().shape({
  fullName: yup.string().required('Field is required'),
  occupation: yup.string().required('Field is required'),
  phoneNumber: yup
    .string()
    .matches(/^[\d+]+$/, 'Only numbers and + allowed')
    .required('Field is required'),
  emailAddress: yup.string().required('Field is required').email('Invalid email format'),
  address: yup.string().required('Field is required'),
})

const ReferenceUpdate: FC<propsType> = ({ toggleModal, selectedRef, onSave }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<ReferenceUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (selectedRef) {
      reset({
        fullName: selectedRef.fullName,
        occupation: selectedRef.occupation,
        phoneNumber: selectedRef.phoneNumber,
        emailAddress: selectedRef.emailAddress,
        address: selectedRef.address,
      })
    } else {
      reset({
        fullName: '',
        occupation: '',
        phoneNumber: undefined,
        emailAddress: '',
        address: '',
      })
    }
  }, [selectedRef, reset])

  const submitNewUserInformation = handleSubmit(async (data) => {
    setRequest(true)
    try {
      await onSave(data)

      toggleModal()
    } finally {
      setRequest(false)
    }
  })

  return (
    <div className='bank-update'>
      <form onSubmit={submitNewUserInformation}>
        {/* School */}
        <div className='form-group'>
          <label htmlFor='fullName'>Full Name</label>
          <input
            type='text'
            id='fullName'
            className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
            {...register('fullName', {})}
          />
          {errors.fullName && <div className='invalid-feedback'>{errors.fullName.message}</div>}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='occupation'>Occupation</label>
          <input
            type='text'
            id='occupation'
            className={`form-control ${errors.occupation ? 'is-invalid' : ''}`}
            {...register('occupation', {})}
          />
          {errors.occupation && <div className='invalid-feedback'>{errors.occupation.message}</div>}
        </div>
        <div className='form-group mt-3'>
          <label htmlFor='phone'>Phone Number</label>
          <input
            type='text'
            inputMode='numeric'
            id='phone'
            className={`form-control ${errors.phoneNumber ? 'is-invalid' : ''}`}
            {...register('phoneNumber', {})}
          />
          {errors.phoneNumber && (
            <div className='invalid-feedback'>{errors.phoneNumber.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='email'>Email Address</label>
          <input
            type='text'
            id='email'
            className={`form-control ${errors.emailAddress ? 'is-invalid' : ''}`}
            {...register('emailAddress', {})}
          />
          {errors.emailAddress && (
            <div className='invalid-feedback'>{errors.emailAddress.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <label htmlFor='address'>Address</label>
          <input
            type='text'
            id='address'
            className={`form-control ${errors.address ? 'is-invalid' : ''}`}
            {...register('address', {})}
          />
          {errors.address && <div className='invalid-feedback'>{errors.address.message}</div>}
        </div>

        <div className='form-group mt-4'>
          <button disabled={request} className='btn btn-default-2 w-100' type='submit'>
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default ReferenceUpdate
